<template>
  <div v-if="isLoaded" style="min-height: 100vh;background-color: #F9FAFD">
    <div style="position: relative;margin-bottom: 70px">
      <img src="@/assets/home/sy.png" style="width: 100%;border-radius: 0 0 50% 50% / 0 0 20% 20%;height: 50%">
      <div style="background: white;border-radius: 12px;
        background: rgba(255, 255, 255, 1);box-shadow: 0 10px 15px rgba(82, 82, 82, 0.07);
        position: absolute;width: 92%;top: 150px;margin: 4%;">
        <div style="padding: 16px">
          <van-row gutter="20">
            <van-col span="8">
              <router-link to="/user">
                <div style="text-align: center">
                  <img src="@/assets/home/sqbl.png" style="width: 50%">
                  <div style="margin-top: 5px">
                    个人信息
                  </div>
                </div>
              </router-link>
            </van-col>
            <van-col span="8">
              <router-link :to="{name:'ApplicationList'}">
                <div style="text-align: center">
                  <img src="@/assets/home/szsearch.png" style="width: 50%">
                  <div style="margin-top: 5px">
                    个人业务
                  </div>
                </div>
              </router-link>
            </van-col>
            <van-col span="8">
              <router-link :to="{name:'Houses'}">
                <div style="text-align: center">
                  <img src="@/assets/home/search.png" style="width: 50%">
                  <div style="margin-top: 5px">
                    房产信息
                  </div>
                </div>
              </router-link>
            </van-col>
          </van-row>
          <van-row gutter="20" style="margin-top: 15px;">
            <van-col span="8">
              <router-link to="/application/start">
                <div style="text-align: center">
                  <img src="@/assets/home/sqbl.png" style="width: 50%">
                  <div style="margin-top: 5px">
                    网上申请
                  </div>
                </div>
              </router-link>
            </van-col>
            <van-col span="8">
              <router-link to="/query/certificate">
                <div style="text-align: center">
                  <img src="@/assets/home/szsearch.png" style="width: 50%">
                  <div style="margin-top: 5px">
                    证书查询
                  </div>
                </div>
              </router-link>
            </van-col>
            <van-col span="8">
              <router-link to="/query/bdcmap">
                <div style="text-align: center">
                  <img src="@/assets/home/search.png" style="width: 50%">
                  <div style="margin-top: 5px">
                    三维可视化
                  </div>
                </div>
              </router-link>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div style="height: 80px;"></div>
    <div style="background-color: white;padding:12px 16px;margin:12px;border-radius: 8px"
         v-for="menuGroup in menuGroups" :key="menuGroup.id"
    >
      <div style="font-size: 16px;margin-bottom: 8px">
        {{ menuGroup.name }}
      </div>
      <div>
        <van-row>
          <van-col span="12" v-for="menu in menuGroup.weChatMenus" :key="menu.id"
                   style="margin-bottom: 8px;padding-right: 6px">
            <div style="background-color:  rgb(239, 242, 251);padding:8px 12px;border-radius: 6px;"
                 @click="handleGridItemClick(menu)">
              <div style="display: flex;align-content: center">
                <van-icon
                    slot="icon"
                    :name="menu.iconClass|iconName"
                    :color="menu.iconColor|iconColor"
                    size="16px"
                    class-prefix="iconfont"
                />
                <div style="margin-left: 3px">
                  {{ menu.title }}
                </div>
              </div>
              <div style="font-size: 12px;color: rgb(147, 147, 147);margin-top: 3px">
                {{ menu.subTile }}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!--    安全高度-->
    <div style="height: 30px"></div>
  </div>
</template>

<script>
import {getMenuGroupList} from '@/api/menu'
import {isExternal} from '@/utils/index'
import {Toast} from 'vant'
import {getSystemConfig} from '@/api/systemConfig.js'

export default {
  filters: {
    iconName(name) {
      return name || 'all'
    },
    iconColor(color) {
      return color || '#666'
    }
  },
  data() {
    return {
      value: '',
      isLoaded: false,
      menuGroups: [],
      qxdm: null
    }
  },
  computed: {},
  created() {
    // 显示加载进度
    Toast.loading({
      message: '加载中...',
      duration: 0
    })
    // 加载数据
    this.loadData().then(response => {
      // 加载成功，清除加载进度
      Toast.clear()
    }).catch(error => {
      // 加载失败，显示错误信息
      Toast.fail(error.message)
    })
    // 获取系统配置
    this.loadSystemConfig()
  },
  methods: {
    loadData() {
      return new Promise((resolve, reject) => {
        getMenuGroupList({
          isEnabled: true,
          eagerLoadingProperties: 'WeChatMenus'
        }).then(response => {
          const menuGroups = response.data
          menuGroups.forEach(menuGroup => {
            menuGroup.weChatMenus = menuGroup.weChatMenus.filter(menu => menu.isEnabled).sort((a, b) => a.orderNo - b.orderNo)
            if (menuGroup.weChatMenus) {
              menuGroup.weChatMenus.map(data => {
                if (data.name && data.name.indexOf('|') >= 0) {
                  data.title = data.name.split('|')[0]
                  data.subTile = data.name.split('|')[1]
                } else {
                  data.title = data.name.split('|')[0]
                  data.subTile = data.name.split('|')[0]
                }
              })
            }
          })
          this.menuGroups = menuGroups
          this.isLoaded = true
          resolve(menuGroups)
        }).catch(error => {
          reject(error)
        })
      })
    },
    handleGridItemClick(menu) {
      if (menu.url) {
        // switch (menu.code) {
        //   case 'application-shortcut':
        //     Toast('敬请期待')
        //     return
        //   case 'application-start':
        //     Toast('敬请期待')
        //     return
        // }
        if (isExternal(menu.url)) {
          window.location.href = menu.url
        } else {
          this.$router.push({path: menu.url})
        }
      }
    },
    // 获取系统配置（区县代码）
    loadSystemConfig() {
      getSystemConfig({
        'key': 'DJXT_QXDM'
      }).then(response => {
        this.qxdm = response.data.value
      })
    },
    searchInfo() {

    }
  }
}
</script>

<style scoped lang="scss">
body {
  background-color: #EBECED !important;
}

div {
  font-size: 14px;
}

.van-cell {
  border-radius: 4px;
  background: #888888;
  color: white;
}

.van-field__control {
  color: white !important;
}

.home {
  height: 100%;
  padding: 10px;
  background-color: #f7f7f7;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
}

.card {
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
  background-color: #fff;

  .card__title {
    color: #666666;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    font-weight: normal;
    text-indent: 20px;
    margin: 0px;
  }

  .van-grid {
    .van-grid-item {
      .van-grid-item__content {
        .grid-item__label {
          margin-top: 5px;
          line-height: 22px;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }
}

.card.header {
  text-align: center;
  background-color: #3bac6a;
  padding: 20px 0px;

  .link-item {
    display: block;
    width: 36px;
    margin: 32px auto 0px;
    text-align: center;

    .link-item__label {
      color: #fff;
      font-size: 14px;
    }
  }
}

input {
  color: #ffffff !important;
}
</style>
